import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.99609 7.99616C6.20523 7.99616 7.99609 6.2053 7.99609 3.99616C7.99609 3.26136 7.79797 2.57285 7.45222 1.98111C8.83829 1.35094 10.3782 0.999941 12 0.999941C18.0751 0.999941 23 5.92481 23 11.9999C23 18.0751 18.0751 22.9999 12 22.9999C5.92487 22.9999 1 18.0751 1 11.9999C1 10.3782 1.35097 8.83834 1.9811 7.45231C2.57282 7.79804 3.26132 7.99616 3.99609 7.99616ZM16.5161 8.93354H14.5122V10.9374H16.5161V8.93354ZM10.3979 14.0583L9.90942 13.1857L8.16432 14.1628L8.65284 15.0353C9.30758 16.2048 10.5608 16.9989 12.0008 16.9989C13.4408 16.9989 14.694 16.2048 15.3488 15.0353L15.8373 14.1628L14.0922 13.1857L13.6037 14.0583C13.2882 14.6217 12.6879 14.9989 12.0008 14.9989C11.3137 14.9989 10.7134 14.6217 10.3979 14.0583ZM7.46289 8.93421V10.9381H9.4668V8.93421H7.46289Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.99646 0.695068L5.09356 2.89911L7.2976 3.99621L5.09356 5.09332L3.99646 7.29736L2.89935 5.09332L0.695312 3.99621L2.89935 2.89911L3.99646 0.695068Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.8313 20.8188L19.2625 21.5997L20.8313 22.3806L21.6122 23.9495L22.3932 22.3806L23.962 21.5997L22.3932 20.8188L21.6122 19.25L20.8313 20.8188Z"}}]};

const FaceRetouchingFilled = Vue.extend<IconProps>({
  name: 'FaceRetouchingFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'face-retouching-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FaceRetouchingFilled;
